module.exports = __webpack_public_path__ + "img/stackslash-24.74a3d7d0.jpg";